import VueRouter from 'vue-router';
import App from './App.vue'

let routes = [
    { path: '/', component: App},
    { path: '/:lng', component: App, props:true }  
];

const router = new VueRouter({
    mode: 'history',
    routes,
    linkActiveClass: 'active'
});

export default router
